import React, {useMemo} from "react";
import ReactModal from "react-modal";
import Separator from "../Separator/Separator";
import './modal.scss';
import {ReactComponent as CloseIcon} from "../../../assets/close.svg";
import {ReactComponent as BackIcon} from "../../../assets/back.svg";
import useResize from "../../../hooks/useResize";

function Modal({title, height, width, isOpen, setIsOpen, multistep, backHandler, children}) {
    const { windowWidth } = useResize();

    const mobileView = useMemo(() => windowWidth <= 600, [windowWidth]);
    return (
        <ReactModal
            ariaHideApp={false}
            isOpen={isOpen}
            onRequestClose={() => setIsOpen(false)}
            contentLabel={title}
            style={{
                overlay: {
                    backgroundColor: "rgba(100, 100, 100, 0.5)",
                },
                content: {
                    position: "absolute",
                    transform: "translate(-50%, -10%)",
                    top: 200,
                    left: "50%",
                    width: mobileView ? "100%" : 600,
                    height: height,
                    boxSizing: "border-box",
                    border: "none",
                    boxShadow: "0px 40px 60px rgba(105, 123, 140, 0.3), 0px 10px 30px rgba(105, 123, 140, 0.4)",
                    borderRadius: 16,
                    padding: 20,
                    fontFamily: "Geometria, sans-serif",
                    color: "black",
                    fontWeight: 400
                }
            }}
        >
            <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                {multistep && (backHandler ? (
                    <div style={{cursor: "pointer", display: "flex", alignItems: "center"}} onClick={backHandler}>
                        <BackIcon />
                        <span style={{color: "var(--grey0)", fontWeight: 600, marginLeft: 10, marginTop: 4}}>Back</span>
                    </div>
                ) : (
                    <div/>
                ))}
                <span>{title}</span>
                <div style={{cursor: "pointer"}} onClick={() => setIsOpen(false)}>
                    <CloseIcon />
                </div>
            </div>
            <Separator />
            {children}
        </ReactModal>
    );
}

export default Modal;
